// src/admin/pages/AdBannersPage.jsx

import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

import PageHeader from "../components/PageHeader";
import SearchInput from "../components/SearchInput";
import BannersTable from "../components/BannersTable";

import useBanners from "../hooks/useBanners";

export default function BannersPage() {

    const navigate = useNavigate();

    const [search, setSearch] = useState("");

    const {

        banners,

        loading,

        deletingId,

        deleteBanner,

    } = useBanners(search);

    const handleEdit = (banner) => {

        navigate(`/admin/banners/${banner.id}/edit`);

    };

    return (

        <div className="space-y-8">

            <PageHeader
                title="Ad Banners"
                subtitle="Advertisement Management"
                actionButton={

                    <Link
                        to="/admin/banners/create"
                        className="
                            px-6
                            py-3
                            rounded-xl
                            bg-blue-800
                            text-white
                            font-semibold
                            hover:bg-blue-600
                            transition
                        "
                    >
                        Create Banner
                    </Link>

                }
            />

            <SearchInput
                value={search}
                onChange={setSearch}
                placeholder="Search banners..."
            />

            {loading ? (

                <div className="py-16 text-center">
                    Loading banners...
                </div>

            ) : (

                <BannersTable
                    banners={banners}
                    deletingId={deletingId}
                    onEdit={handleEdit}
                    onDelete={deleteBanner}
                />

            )}

        </div>

    );

}